import React, { useEffect, useRef, useState } from 'react';
import {
  Form,
  Button,
  Space,
  Input,
  Message,
  Modal,
  Spin,
} from '@arco-design/web-react';
import './style/style.less';
import { useLocation, useHistory } from 'react-router-dom';
// import logoradioa from '@/assets/iconimage/radioa.png';
// import logoradiob from '@/assets/iconimage/radiob.png';
import { observer } from 'mobx-react-lite';
import './sliderCaptcha.css';
import { appStore, userStore } from '@/mobx';
import axios from 'axios';

const FormItem = Form.Item;
const Smslogin = (props: any) => {
  const { login } = props;
  const history = useHistory();
  const [form] = Form.useForm();
  const [radioopp, setradioopp] = useState(0);
  const formrefSmlong = useRef(form);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [urlstate, setstate] = useState(null);
  const captchaRef = useRef(null);
  const [vertifyVisible, setVertifyVisible] = useState(false);

  useEffect(() => {
    try {
      const code = location.search.split('=')[1];
      setstate(code);
    } catch (e) {}
  }, [location]);

  // useEffect(() => {
  //   if (login.isSuccess) {
  //     setTimeout(() => {
  //       // if (urlstate) {
  //       //   navigate(`/invite?code=${urlstate}`);
  //       // } else {
  //       // }
  //       const searchParams = new URLSearchParams(location.search);
  //       const next = searchParams.get('next') || '/';
  //       history.push(next, { replace: true });
  //       login.isSuccess = false;
  //     }, 600);
  //   }
  // }, [login.isSuccess]);

  async function onSubmitClick() {
    if (!radioopp && !appStore.isOdm) {
      Message.info('请勾选用户协议!');
    } else {
      try {
        const value = await formrefSmlong.current.validate();
        setLoading(true);
        // eslint-disable-next-line react/prop-types
        const result = await login.smslong_login_sms(value);
        // setTokenToLocalStorage();
        setLoading(false);
      } catch (res) {}
    }
  }

  async function validateCaptcha(value, callback) {
    const { getFieldValue } = formrefSmlong.current;
    const phone_number = getFieldValue('phone_number');
    const regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if (!regex.test(phone_number)) {
      return;
    }
    if (!value) {
      callback(<div>验证码不能为空</div>);
    } else {
      await login.verifyCode_to(formrefSmlong).then((res) => {
        if (res == 'ok') {
          callback();
        } else if (res == 'no') {
          callback(<div>验证码错误</div>);
        }
      });
    }
  }

  const validatePhoneNumber = (value, callback) => {
    const element = document.getElementById('opa') as HTMLButtonElement;
    const elementnode = document.querySelector(
      '.forminputerror'
    ) as HTMLDivElement;
    const regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if (!value) {
      element.disabled = true;
      element.style.color = '#666666';
      elementnode.style.display = 'none';
      callback(<div>手机号不能为空！</div>);
    } else if (!regex.test(value)) {
      callback(<div>手机号格式不正确,请重新输入</div>);
      element.disabled = true;
      element.style.color = '#666666';
      elementnode.style.display = 'none';
      element.style.cursor = 'default';
    } else {
      element.disabled = false;
      element.style.color = '#165DFF';
      elementnode.style.display = 'block';
      element.style.cursor = 'pointer';
      callback();
    }
  };

  const sendCode = async () => {
    login.sendCode_to(formrefSmlong);
    const et = document.getElementById('opa') as HTMLButtonElement;
    et.disabled = true;
    et.style.color = '#666666';
    let count = 60;
    const regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
    const countdownInterval = setInterval(() => {
      et.style.cursor = 'default';
      et.innerHTML = `${count - 1}秒后重发`;
      count--;
      if (count <= 0 && formrefSmlong.current) {
        const { getFieldValue } = formrefSmlong.current;
        const phone_number = getFieldValue('phone_number');
        if (!regex.test(phone_number)) {
          et.innerHTML = `重新发送`;
          et.style.color = '#666666';
          clearInterval(countdownInterval);
          et.disabled = true;
          et.style.cursor = 'default';
        } else {
          et.innerHTML = `重新发送`;
          et.style.color = '#165DFF ';
          clearInterval(countdownInterval);
          et.disabled = false;
          et.style.cursor = 'pointer';
        }
      }
    }, 1000);
  };

  // useEffect(() => {
  //   if (!vertifyVisible) return;

  //   setTimeout(() => {
  //     if (captchaRef.current) {
  //       captchaRef.current.reset();
  //       return;
  //     }
  //     captchaRef.current = window.sliderCaptcha(
  //       {
  //         id: 'captcha',
  //         width: 340,
  //         height: 200,
  //         sliderL: 42,
  //         sliderR: 9,
  //         offset: 8, // 验证容错偏差值
  //         loadingText: '正在加载中...',
  //         failedText: '再试一次',
  //         barText: '向右滑动填充拼图',
  //         // repeatIcon: "fa fa-repeat",
  //         setSrc: function () {
  //           return `https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/public/login/${
  //             Math.floor(Math.random() * 5) + 1
  //           }.jpg`;
  //         },
  //         remoteUrl: '/api/v1/user/verify',
  //         onImgLoading() {
  //           console.log('image Loading');
  //           setVerifyLoading(true);
  //         },
  //         onImgLoaded() {
  //           console.log('image Loaded');
  //           setVerifyLoading(false);
  //         },
  //         verify: async (arr, url) => {
  //           const data = await axios.post(url, { datas: arr });
  //           return data.data.success;
  //         },
  //         onSuccess: async function () {
  //           //成功事件
  //           await sendCode();
  //           setTimeout(() => {
  //             setVertifyVisible(false);
  //           }, 1500);
  //         },
  //         onRefresh: function () {
  //           console.log('刷新事件');
  //         },
  //       },
  //       40
  //     );
  //   });
  // }, [vertifyVisible]);

  return (
    <>
      <Form className="form-cottopre" ref={formrefSmlong} autoComplete="off">
        <FormItem
          field="phone_number"
          rules={[
            { validator: validatePhoneNumber, validateTrigger: 'onBlur' },
          ]}
        >
          <Input
            className="form-contorinput"
            autoComplete="username"
            allowClear={true}
            placeholder="请输入手机号"
          />
        </FormItem>
        <div className="forminputerror">
          短信登录手机账号,未注册用户将自动创建账号
        </div>
        <FormItem
          field="code"
          rules={[{ validator: validateCaptcha, validateTrigger: 'onBlur' }]}
        >
          <Input
            placeholder="请输入验证码"
            autoComplete="current-password"
            suffix={
              <div className="inputyzmbody">
                <div id="inputyzmi"></div>
                <button
                  id="opa"
                  style={{ color: '#666', background: 'transparent' }}
                  onClick={async () => {
                    try {
                      await formrefSmlong.current.validate(['phone_number']);
                      setVertifyVisible(true);
                    } catch (error) {
                      console.error(error);
                    }
                  }}
                >
                  获取验证码
                </button>
              </div>
            }
          />
        </FormItem>

        <Space direction="vertical" style={{ marginTop: '32px' }}>
          <Button
            type="primary"
            long
            onClick={async () => {
              onSubmitClick();
            }}
            loading={loading}
            className="styleInputbutton"
          >
            登录
          </Button>
          {/* {!appStore.isOdm ? (
            <div className="radiobody" style={{ cursor: 'pointer' }}>
              {radioopp === 0 ? (
                <div
                  className="logi_form_titlerekeli"
                  onClick={() => {
                    setradioopp(1);
                  }}
                >
                  <p className="ardioactiveer"></p>
                  <span>我已阅读并同意</span>
                </div>
              ) : (
                <div
                  className="logi_form_titlerekeli"
                  onClick={() => {
                    setradioopp(0);
                  }}
                >
                  <img src={logoradiob} alt="" className="ardioactive" />
                  <span>我已阅读并同意</span>
                </div>
              )}
              <span className="login-form-itemhover">
                <span
                  style={{
                    color: '#165dff',
                  }}
                  onClick={() => {
                    // window.open("/policy.html", "policy");
                  }}
                >
                  平台隐私政策
                </span>
                &nbsp; 与&nbsp;
                <span
                  style={{
                    color: '#165dff',
                  }}
                  onClick={() => {
                    // window.open("/agreement.html", "agreement");
                  }}
                >
                  平台用户服务协议
                </span>
              </span>
            </div>
          ) : null} */}
        </Space>
      </Form>

      <Modal
        title="请完成下列验证后继续"
        style={{ width: 400, height: 340, right: '-25%' }}
        visible={vertifyVisible}
        footer={null}
        onOk={() => setVertifyVisible(false)}
        onCancel={() => setVertifyVisible(false)}
        autoFocus={false}
        focusLock={true}
      >
        <Spin
          loading={verifyLoading}
          tip="加载中..."
          size={24}
          style={{ position: 'absolute', width: '100%' }}
        >
          <div style={{ paddingTop: 18 }}>
            <div id="captcha"></div>
          </div>
        </Spin>
      </Modal>
    </>
  );
};
export default observer(Smslogin);
